import script from "./RootMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RootMenu.vue?vue&type=script&setup=true&lang=js"

import "./RootMenu.vue?vue&type=style&index=0&id=7ff5359c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff5359c"]])

export default __exports__